<dx-box #workflowVendorMissingBillsBox height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto">
        <h2 class="page-header">
            Vendor Missing Bills
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
            <i
                class="launch-page-link dx-theme-accent-as-text-color"
                title="Open page in new window"
                [ngClass]="iconRestore"
                (click)="openPageInWindow()"
            ></i>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="cc-white-background box-grid-container">
        <dx-box width="100%" height="100%" direction="col" class="box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="row">
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <div class="row-container">
                                    <div *ngIf="!selectedContext" class="field-component-container padding-right">
                                        <div class="padding-right">Community</div>
                                        <div class="field-component">
                                            <app-multi-column-selector
                                                [name]="'Community'"
                                                [cssClass]="'community-width'"
                                                [disabled]="!!selectedContext?.communityId"
                                                [gridSource]="communityList"
                                                [boxValue]="communityGridBoxValue"
                                                [valueExpr]="'communityId'"
                                                [displayExpr]="'communityName'"
                                                [columnDef]="communityColumns"
                                                [dropDownButtonTemplate]="'dropDownButton'"
                                                [dropDownOptions]="{ width: 'auto' }"
                                                [showClearButton]="true"
                                                [navigateToCommunity]="true"
                                                [placeholder]="'All Communities...'"
                                                [showHeaderFilters]="true"
                                                (gridSelectionEvent)="onCommunitySelection($event)"
                                            ></app-multi-column-selector>
                                        </div>
                                    </div>
                                    <div class="short-field-component-container padding-right">
                                        <div class="padding-right">Mode</div>
                                        <div class="short-field-component">
                                            <dx-select-box
                                                displayExpr="displayText"
                                                valueExpr="value"
                                                [dataSource]="modesOptions"
                                                [(value)]="selectedMode"
                                                (onValueChanged)="onModeOptionValueChange()"
                                            ></dx-select-box>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" [visible]="selectedMode !== 'UnResolved'">
                            <div *dxTemplate>
                                <div class="row-container">
                                    <div class="field-medium padding-right">Missing Invoice Date</div>

                                    <div class="medium-field-component-container padding-right">
                                        <div class="padding-right">From</div>
                                        <div class="short-field-component">
                                            <dx-date-box
                                                type="date"
                                                [showClearButton]="true"
                                                [(value)]="missingInvoiceFromDate"
                                            ></dx-date-box>
                                        </div>
                                    </div>

                                    <div class="medium-field-component-container padding-right">
                                        <div class="padding-right">To</div>
                                        <div class="short-field-component">
                                            <dx-date-box
                                                type="date"
                                                [showClearButton]="true"
                                                [(value)]="missingInvoiceToDate"
                                            ></dx-date-box>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item baseSize="auto">
                            <div *dxTemplate>
                                <div class="button-container">
                                    <dx-button
                                        type="default"
                                        text="View / Refresh"
                                        [icon]="iconRefresh"
                                        (onClick)="onRefreshClick()"
                                    ></dx-button>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" [visible]="selectedMode === 'UnResolved'"></dxi-item>
                    </dx-box>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        *ngIf="!!vendorMissingBills"
                        [stateConfig]="{ storageKey: 'WORKFLOW_VENDOR_MISSING_BILLS', storeGroupings: true }"
                        [dataSource]="vendorMissingBills"
                    >
                        <dx-data-grid
                            #vendorEditGrid
                            appHasInternalUserColumns
                            width="100%"
                            height="100%"
                            [dataSource]="vendorMissingBills"
                        >
                            <dxi-column
                                type="buttons"
                                caption="Action"
                                alignment="center"
                                [visibleIndex]="0"
                                [showInColumnChooser]="false"
                            >
                                <dxi-button template="template">
                                    <div *dxTemplate="let row of 'template'">
                                        <app-grid-actions-menu
                                            [actionMenuItems]="actionMenuItems"
                                            [record]="row.data"
                                            [rowIndex]="row.rowIndex"
                                            (onActionClick)="onActionClick($event)"
                                        ></app-grid-actions-menu>
                                    </div>
                                </dxi-button>
                            </dxi-column>

                            <dxi-column
                                dataType="string"
                                dataField="community"
                                caption="Community"
                                cellTemplate="communityCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="vendor"
                                caption="Vendor Name"
                                cellTemplate="vendorNameCellTemplate"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="accountNumber" caption="Account No."></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="missingInvoiceDate"
                                caption="Missing Invoice Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="originalInvoiceDate"
                                caption="Previous Invoice Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column dataType="number" dataField="dayMissing" caption="Days Missing"></dxi-column>
                            <dxi-column
                                dataType="number"
                                dataField="workflowMissingBillQueueId"
                                caption="WF Missing Bill Queue Id"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="workflowId"
                                caption="Previous WF_JOB_ID"
                            ></dxi-column>
                            <dxi-column
                                name="InternalNotes"
                                dataField="hasNotes"
                                dataType="boolean"
                                caption="Notes"
                                cellTemplate="notesCellTemplate"
                                alignment="center"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column
                                name="InternalLogs"
                                caption="Log"
                                cellTemplate="historyCellTemplate"
                                alignment="center"
                                [allowGrouping]="false"
                            ></dxi-column>
                            <dxi-column dataType="number" dataField="frequency" caption="Frequency"></dxi-column>
                            <dxi-column dataType="string" dataField="status" caption="Status"></dxi-column>
                            <dxi-column
                                dataType="boolean"
                                dataField="eftActive"
                                caption="EFT"
                                cellTemplate="eftCellTemplate"
                                alignment="center"
                            ></dxi-column>
                            <dxi-column
                                dataType="boolean"
                                dataField="isResolved"
                                caption="Resolved"
                                cellTemplate="resolvedCellTemplate"
                                alignment="center"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="dateAdded"
                                caption="Date Added"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataType="number"
                                dataField="invoicesForAccountCount"
                                caption="Invoice For Account"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="lastModifiedByDisplayText"
                                caption="Last Modified By"
                                cellTemplate="lastModifiedCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="lastModifiedDate"
                                caption="Last Modified On"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataType="number"
                                dataField="possibleResolvedByWorkflowId"
                                caption="Possibly Resolved By"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="possibleResolvedByStatus"
                                caption="Possibly Resolved AAP Workflow Status"
                            ></dxi-column>
                            <dxi-column
                                dataType="boolean"
                                dataField="accountActive"
                                caption="Active"
                                cellTemplate="activeCellTemplate"
                                alignment="center"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="location" caption="Location"></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="accountantDisplayText"
                                caption="Accountant"
                                cellTemplate="accountantCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="dcamDisplayText"
                                caption="DCAM"
                                cellTemplate="dcamCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataType="string"
                                dataField="camDisplayText"
                                caption="CAM"
                                cellTemplate="camCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="contractStartDate"
                                caption="Contract Start Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="vendorCode" caption="Vendor Code"></dxi-column>

                            <div *dxTemplate="let row of 'communityCellTemplate'">
                                <app-property-community-link
                                    [communityId]="row.data.communityId"
                                    [displayText]="row.value"
                                ></app-property-community-link>
                            </div>

                            <div *dxTemplate="let d of 'eftCellTemplate'">
                                <div *ngIf="d.data.eftActive">
                                    <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                </div>
                            </div>
                            <div *dxTemplate="let d of 'resolvedCellTemplate'">
                                <div *ngIf="d.data.isResolved">
                                    <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                </div>
                            </div>
                            <div *dxTemplate="let d of 'activeCellTemplate'">
                                <div *ngIf="d.data.accountActive">
                                    <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                </div>
                            </div>

                            <div *dxTemplate="let a of 'historyCellTemplate'">
                                <i
                                    class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                    [ngClass]="iconHistory"
                                    (click)="onHistoryClick(a.data)"
                                ></i>
                            </div>

                            <div *dxTemplate="let d of 'notesCellTemplate'">
                                <div *ngIf="d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-data-content cc-icon-content cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onNotesClick(d.data)"
                                    ></i>
                                </div>

                                <div *ngIf="!d.data.hasNotes">
                                    <i
                                        class="cc-1-5x icon-data-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onNotesClick(d.data)"
                                    ></i>
                                </div>
                            </div>
                            <div *dxTemplate="let r of 'accountantCellTemplate'" class="responsible-container">
                                <app-user-bio-link
                                    [user]="r.data.accountant"
                                    [communityId]="r.data.communityId"
                                ></app-user-bio-link>
                            </div>
                            <div *dxTemplate="let r of 'dcamCellTemplate'" class="responsible-container">
                                <app-user-bio-link
                                    [user]="r.data.dcam"
                                    [communityId]="r.data.communityId"
                                ></app-user-bio-link>
                            </div>
                            <div *dxTemplate="let r of 'camCellTemplate'" class="responsible-container">
                                <app-user-bio-link
                                    [user]="r.data.cam"
                                    [communityId]="r.data.communityId"
                                ></app-user-bio-link>
                            </div>
                            <div *dxTemplate="let r of 'lastModifiedCellTemplate'" class="responsible-container">
                                <app-user-bio-link
                                    [user]="r.data.lastModifiedBy"
                                    [communityId]="r.data.communityId"
                                ></app-user-bio-link>
                            </div>

                            <div *dxTemplate="let r of 'vendorNameCellTemplate'">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    actionCode="VENDOR_MANAGEMENT"
                                    [displayText]="r.value"
                                    (onLinkClick)="onVendorNameClick(r.data)"
                                ></app-hyperlink-creator>
                            </div>

                            <dxo-summary>
                                <dxi-group-item
                                    column="workflowId"
                                    summaryType="count"
                                    displayFormat="Count = {0}"
                                ></dxi-group-item>
                            </dxo-summary>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<app-update-vendor-missing-bill-status
    *ngIf="showUpdateVendorMissingBill"
    [mode]="selectedMode"
    [workflowMissingBill]="selectedVendorMissingBill"
    (onClose)="onUpdateMissingBillClose($event)"
></app-update-vendor-missing-bill-status>

<app-vendor-missing-bill-history
    *ngIf="showVendorMissingBillHistory"
    [missingBillQueueId]="selectedVendorMissingBill.workflowMissingBillQueueId"
    [communityId]="selectedVendorMissingBill.communityId"
    (onClose)="onHistoryClose()"
></app-vendor-missing-bill-history>

<app-vendor-account-notes
    *ngIf="showVendorAccountNotes"
    [communityId]="selectedVendorMissingBill.communityId"
    [hasNotes]="selectedVendorMissingBill.hasNotes"
    [associationVendorId]="selectedVendorMissingBill.communityVendorId"
    [vendorAccountId]="selectedVendorMissingBill.vendorAccountId"
    [accountNumber]="selectedVendorMissingBill.accountNumber"
    (vendorAccountNotesClose)="onVendorAccountNotesClose($event)"
></app-vendor-account-notes>

<app-manage-vendor-accounts
    #manageVendorAccount
    *ngIf="showManageVendorAccountPopup"
    [workflowId]="selectedVendorMissingBill?.workflowId"
    [vendorCode]="selectedVendorMissingBill?.vendorCode"
    [vendorName]="selectedVendorMissingBill?.vendor"
    [associationVendorId]="selectedVendorMissingBill?.communityVendorId"
    [communityId]="selectedVendorMissingBill?.communityId"
    [communityName]="selectedVendorMissingBill?.community"
    (closeManageVendorAccounts)="onManageVendorAccountClose()"
    (onVendorAccountEditorClick)="onVendorAccountSelectionForEditor($event)"
></app-manage-vendor-accounts>

<app-vendor-account-editor
    #vendorAccountEditorConfig
    *ngIf="showAddEditVendorAccount"
    [title]="addEditVendorAccountPopUpTitle"
    [configMode]="vendorAccountConfigMode"
    [communityId]="selectedVendorMissingBill?.communityId"
    [vendorName]="selectedVendorMissingBill?.vendor"
    [associationVendorId]="selectedVendorMissingBill?.communityVendorId"
    [vendorAccount]="selectedVendorAccountForEditor"
    (closeVendorAccount)="onVendorAccountEditorClose($event)"
></app-vendor-account-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowVendorMissingBillsBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
